// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateCompanyMutation($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      company {
        id
        name
        namespace
        timezone
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        addressCountry
        phone
        sundayHoursStart
        sundayHoursEnd
        mondayHoursStart
        mondayHoursEnd
        tuesdayHoursStart
        tuesdayHoursEnd
        wednesdayHoursStart
        wednesdayHoursEnd
        thursdayHoursStart
        thursdayHoursEnd
        fridayHoursStart
        fridayHoursEnd
        saturdayHoursStart
        saturdayHoursEnd
        currency
        pickMethod
        autoEmailOnOrderCreated
        autoEmailOnInvoiceCreated
        autoEmailOnShipmentCreated
        upsClientId
        upsClientSecret
        upsAccountNumber
        upsShipperName
        upsShipperPhone
        upsShipperAddressLine1
        upsShipperAddressLine2
        upsShipperAddressCity
        upsShipperAddressState
        upsShipperAddressZip
        upsShipperAddressCountry
        calendarEvents {
          id
          name
          isFullDay
          isOpen
          startAt
          endAt
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
